module.exports = __webpack_public_path__ + "static/media/haute10A.33dee545.jpg";